import { createSlice } from '@reduxjs/toolkit';
import { algorithmOrderAdapter } from '../../../resources/AlgorithmOrder.resource';
var initialState = {
    data: []
};
export var AlgorithmsOrdersReducer = createSlice({
    name: 'algorithmOrders',
    initialState: initialState,
    reducers: {
        init: function init(state, payloadAction) {
            var data = [];
            payloadAction.payload.forEach(function (item) {
                data.push(algorithmOrderAdapter(item));
            });
            state.data = data;
        }
    }
});
var init = AlgorithmsOrdersReducer.actions.init;
export { init };
export default AlgorithmsOrdersReducer.reducer;
